class MimeTypes {
  constructor() {
    this.mimeTypes = {
      image: [
        'image/png',
        'image/jpeg',
        'image/jpg',
        'image/gif',
        'image/webp',
        'image/svg',
        'image/svg+xml'
      ],
      video: [
        'video/mp4'
      ],
      file: {
        audio: [
          'audio/mpeg3',
          'audio/x-mpeg-3',
          'video/mpeg',
          'video/x-mpeg',
          'audio/mp3',
          'audio/mpeg'
        ],
        pdf: [
          'application/pdf',
          'application/x-pdf',
          '.pdf'
        ],
        doc: [
          'application/msword',
          'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
        ],
        xls: [
          'application/excel',
          'application/vnd.ms-excel',
          'application/x-excel',
          'application/x-msexcel',
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        ],
        ppt: [
          'application/mspowerpoint',
          'application/powerpoint',
          'application/vnd.ms-powerpoint',
          'application/x-mspowerpoint	',
          'application/vnd.ms-powerpoint',
          'application/vnd.openxmlformats-officedocument.presentationml.presentation'
        ],
        txt: [
          'text/plain',
          'text/rtf',
          '.txt'
        ],
        zip: [
          'application/x-compressed',
          'application/x-zip-compressed',
          'application/zip',
          'multipart/x-zip',
          '.zip'
        ],
        image: [
          'image/png',
          'image/jpeg',
          'image/jpg',
          'image/gif',
          'image/svg',
          'image/svg+xml'
        ],
      },
      icon: ['svg']
    };
  }

  getMimeType(type) {
    if (this.mimeTypes[type])
      return this.mimeTypes[type];
    return this.mimeTypes;
  }
};

class Options {
  constructor() {
    this.mimetypes = new MimeTypes();

    this.options = {
      images: {
        action: '/external_images/upload',
        max_size: 5 * 1048576, // 1048576 = 1mb de byte - 5Mbs
        accept: function () {
          let mimeType = new MimeTypes();
          return mimeType.getMimeType('image');
        }
      },
      videos: {
        action: '/external_file/upload-video',
        max_size: 50 * 1048576, //30Mbs
        accept: function () {
          let mimeType = new MimeTypes();
          return mimeType.getMimeType('video');
        }
      },
      files: {
        action: '/external_file/upload-file',
        max_size: 10 * 1048576, //10Mbs
        accept: function () {

          let mimeType = new MimeTypes();
          var types = mimeType.getMimeType('file');
          var response = [];

          for (var index in types) {
            response = [...response, ...types[index]];
          }

          return response;
        }
      }
    };
  }
}

export default Options;



// WEBPACK FOOTER //
// ./src/components/general/FilesManager/options.js